import { NgModule } from '@angular/core';
import * as AllIcons from '@ant-design/icons-angular/icons';
import {IconDefinition} from '@ant-design/icons-angular';
import {NZ_ICONS, NzIconModule} from 'ng-zorro-antd/icon';

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(key => antDesignIcons[key]);

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    {provide: NZ_ICONS, useValue: icons},
  ]
})
export class AntIconModule { }
